import { useEffect } from "react";

const DEFAULT_TITLE = "PK-Forensics";
const DEFAULT_DESCRIPTION =
  "PK-Forensics tarjoaa käytännönläheistä sovelluskehitystä ja digitaalista tutkintaa.";

export default function PageMeta({ title, description }) {
  useEffect(() => {
    document.title = title;

    let descriptionElement = document.querySelector('meta[name="description"]');
    if (!descriptionElement) {
      descriptionElement = document.createElement("meta");
      descriptionElement.setAttribute("name", "description");
      document.head.appendChild(descriptionElement);
    }
    descriptionElement.setAttribute("content", description);

    return () => {
      document.title = DEFAULT_TITLE;
      descriptionElement.setAttribute("content", DEFAULT_DESCRIPTION);
    };
  }, [description, title]);

  return null;
}
